import React, {FunctionComponent, PropsWithChildren, useCallback} from 'react';
import {IconButton, Menu} from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';

export const ActionMenu: FunctionComponent<PropsWithChildren> = ({children}) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);
    const menuRef = React.useRef<HTMLElement>(null);

    const toggle = useCallback(() => {
        setOpen(!open);
    }, [open]);

    const close = useCallback(() => {
        setOpen(false);
    }, []);

    return (
        <>
            <IconButton
                onClick={toggle}
                ref={anchorRef}
            >
                <MoreVert/>
            </IconButton>
            <Menu
                open={open}
                ref={menuRef}
                anchorEl={anchorRef.current}
                getContentAnchorEl={null}
                onClose={close}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                onClick={(e) => {
                    if(menuRef.current?.contains(e.target as Node))
                        close();

                }}
            >
                {children}
            </Menu>
        </>
    );
};
